import { API } from '../../api';
import { STRONG_DATA_MANAGER } from '../../data';

export default {
    namespaced: true,
    state: {
        showStrongBirthdayPop: false,
        showStrongAreaPop: false,
        reportData: {},
        reportBaziData: [],
        reportAIData: {},
        reportStrongInfo: {},
    },
    mutations: {
    },
    actions: {
        addReportBaziInfo({ state, dispatch }, params) {
            API.addPaiPan(params.params, (data) => {
                console.log('添加测算成功::::::::', data);
                state.detailInfo = data;
                dispatch('record/updateRecordListData', data, {root: true});
                if(params.cb && typeof(params.cb) == 'function') {
                    params.cb(data);
                }
            })
        },
        getReportStrongInfo({ state }, params) {
            if(!params.detailInfo.id) { return; }
            console.log('getReportStrongInfo------', params.detailInfo)
            let temp = STRONG_DATA_MANAGER.getReportBaziInfoByData(params.detailInfo);
            state.reportBaziData = [].concat(temp);
            API.getAIStrongInfo({
                hid: params.detailInfo.id
            }, (data) => {
                console.log('获取Strong数据成功:::::::', data);
                state.detailInfo = params.detailInfo;
                state.reportStrongInfo = STRONG_DATA_MANAGER.getReportStrongInfoByData(data);
                if(params.sucCb && typeof(params.sucCb) == 'function') {
                    params.sucCb(data);
                }
            })
        },
        resetData({state}) {
            state.detailInfo = {};
            state.reportData = {};
            state.reportBaziData = [];
            state.reportAIData = {};
            state.reportStrongInfo = {};
        }
    }
}